module.exports = __webpack_public_path__ + "25818ea6b399c99cedcfc0d8e462c3fa.svg";